(function () {
  var STORAGE_KEY = 'lastViewedCollection';

  // Collection pages set window.__collectionBreadcrumbData (inline, before
  // this deferred script runs) so it's recorded as "the collection the
  // shopper is currently browsing" — read back on a product page to decide
  // whether to show a collection segment in its breadcrumb.
  if (window.__collectionBreadcrumbData && window.__collectionBreadcrumbData.title && window.__collectionBreadcrumbData.url) {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(window.__collectionBreadcrumbData));
    } catch (e) {}
  }

  var collectionEl = document.querySelector('[data-breadcrumb-collection]');
  if (!collectionEl) return;

  try {
    // document.referrer keeps the ORIGINAL navigation's referrer across a
    // page reload (a refresh doesn't reset it), but becomes the previous
    // page's own URL when navigating onward to a different product — so
    // gating on it (rather than merely "is anything in sessionStorage")
    // keeps the breadcrumb showing across a refresh of the SAME product page
    // while still hiding it again once the shopper moves to an unrelated one
    // (e.g. via "related products"), without needing to ever clear the
    // stored value.
    var referrerPath = document.referrer && new URL(document.referrer).pathname;
    if (!referrerPath || referrerPath.indexOf('/collections/') !== 0) return;

    var raw = sessionStorage.getItem(STORAGE_KEY);
    var data = raw && JSON.parse(raw);
    if (!data || !data.title || !data.url) return;

    var link = collectionEl.querySelector('[data-breadcrumb-collection-link]');
    link.textContent = data.title;
    link.href = data.url;
    collectionEl.hidden = false;
  } catch (e) {}
})();
